
export default function (Vue) {
  Vue.mixin({
    methods: {
      $auth(rol) {
        return this.$store.state.local.rol.nombre == rol;
      }
    }
  });
}
